<template>
  <ul class="tree">
    <li v-for="item in data" :key="item.id">
      <div class="title" :class="{active: item.active}">
        <div class="checkbox" :class="{active: item.active}"></div>
        <div class="content">
          <img v-if="item.unitAttr === '8'" src="@/assets/image/icon1.png" alt="" />
          <img v-else src="@/assets/image/icon2.png" alt="" />
          <span :class="{active: item.active}" class="van-multi-ellipsis--l2 name" @click="openItem(item)">{{
            item.displayName
          }}</span>
          <template v-if="item.next">
            <van-icon v-if="!item.defaultOpen" name="arrow-down" />
            <van-icon v-else name="arrow-up" />
          </template>
        </div>
      </div>
      <template v-if="item.children && item.children.length && item.defaultOpen">
        <regisTree @getChildren="open" :data="item.children"></regisTree>
      </template>
    </li>
  </ul>
</template>

<script>
import regisTree from '@/views/login/regisTree'
export default {
  name: 'regisTree',
  components: {
    regisTree
  },
  props: {
    data: {
      type: Array
    }
  },
  methods: {
    openItem(item) {
      this.open(item)
    },
    open(item) {
      this.$emit('getChildren', item)
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  transition: all 0.3s linear;
  padding: 10px 0 10px 0;
  padding-left: 20px;
}

.title {
  padding: 8px 0 8px 12px;
  display: flex;
  align-items: center;
  &.active {
    background: #e0efff;
  }
  .checkbox {
    position: relative;
    margin-right: 12px;
    flex: 0 0 18px;
    width: 18px;
    height: 18px;
    border: 1px solid #a1a1a1;
    border-radius: 50%;
    &.active {
      background: #007aff;
      border-color: #007aff;
      &::before {
        opacity: 1;
      }
      &::after {
        opacity: 1;
      }
    }
    &::before {
      content: '';
      position: absolute;
      left: 9px;
      top: 5px;
      width: 2px;
      height: 8px;
      transform: rotate(45deg);
      background: #fff;
      opacity: 0;
    }
    &::after {
      content: '';
      position: absolute;
      position: absolute;
      left: 5px;
      top: 8px;
      width: 2px;
      height: 5px;
      transform: rotate(-45deg);
      background: #fff;
      opacity: 0;
    }
  }
  .content {
    width: 100%;
    display: flex;
    align-items: center;
    img {
      width: 36px;
      height: 36px;
    }
    .name {
      flex: 1;
      font-size: 14px;
      padding-left: 10px;
    }
    span.active {
      color: #4465f3;
    }
  }
}
</style>
